import { addQueryArgs } from '@wordpress/url';
import { getOrderParams } from '../../mixins/property-list';
import { getParamsOfUrl, getUrl } from '../../mixins/search';
import { displayPropertyMapBound, openPopup, closePopup, invalidateSize } from '../../../mixins/map';
import { getQuery } from '../advanced-search/advanced-search';

const searchWithMapNode = document.querySelector( '#realpress-search-with-map' );
let mapPropertyNode, controlNode, sortNode, containerNode, searchNode, mapAreaNode, propertyAreaNode;
//Loadmore
const loadMoreWrapperNode = searchWithMapNode.querySelector( '.realpresss-load-more' );
let loadmoreBtnNode, loadingNode;

//infinite scroll
const infiniteScrollNode = searchWithMapNode.querySelector( '.realpresss-infinite-scroll' );
let infiniteLoadingNode;

const restNamespace = REALPRESS_GLOBAL_OBJECT.rest_namespace || '';
const paginationType = REALPRESS_GLOBAL_OBJECT.pagination_type || '';

let map;
const defaultQuery = { orderby: 'date', order: 'desc', has_coordinates: true, template: 'search_with_map' };
let query = {};
let isFetching = false;
let nextPage = null;
let reseting = false;

const realpressHalfMap = () => {
	if ( ! searchWithMapNode ) {
		return;
	}

	mapPropertyNode = searchWithMapNode.querySelector( '#realpress-map-property-wrapper' );
	mapAreaNode = mapPropertyNode.querySelector( '#realpress-swm-map-area' );
	propertyAreaNode = mapPropertyNode.querySelector( '#realpress-swm-proprerty-area' );
	controlNode = searchWithMapNode.querySelector( '.realpress-control-group' );
	sortNode = controlNode.querySelector( '.realpress-sort-by select' );
	containerNode = searchWithMapNode.querySelector( '.realpress-property-container' );
	searchNode = searchWithMapNode.querySelector( '.realpress-advanced-search' );

	const queryParams = getParamsOfUrl();
	if ( Object.keys( queryParams ).length ) {
		query = { ...query, ...queryParams };
	}

	//Loadmore
	if ( loadMoreWrapperNode ) {
		loadmoreBtnNode = loadMoreWrapperNode.querySelector( '.realpress-load-more-btn' );
		loadingNode = loadMoreWrapperNode.querySelector( '.realpress-loading-display' );
	}

	//Infinite Scroll
	if ( infiniteScrollNode ) {
		infiniteLoadingNode = infiniteScrollNode.querySelector( '.realpress-loading-display' );
	}

	sort();
	if ( searchNode ) {
		reset();
		search();
	}
	getProperties( query );
	pagination();
	switchMobileMap();
};

const switchMobileMap = () => {
	const mobileMapSwitchNode = document.querySelector( '#realpress-mobile-map-switch' );
	if ( ! mobileMapSwitchNode ) {
		return;
	}

	const propertyViewNode = mobileMapSwitchNode.querySelector( '.realpress-property-view' );
	const mapViewNode = mobileMapSwitchNode.querySelector( '.realpress-map-view' );

	propertyViewNode.addEventListener( 'click', function( event ) {
		event.preventDefault();
		propertyViewNode.classList.add( 'active' );
		mapViewNode.classList.remove( 'active' );
		mapAreaNode.style.display = 'none';
		propertyAreaNode.style.display = 'block';
	} );

	mapViewNode.addEventListener( 'click', function( event ) {
		event.preventDefault();
		invalidateSize( map );
		propertyViewNode.classList.remove( 'active' );
		mapViewNode.classList.add( 'active' );
		mapAreaNode.style.display = 'block';
		propertyAreaNode.style.display = 'none';
	} );
};
const getProperties = ( queryParam = {}, isLoadmore = false ) => {
	if ( isLoadmore === false ) {
		containerNode.style.opacity = 0.4;
	}
	const param = { ...defaultQuery, ...queryParam };

	wp.apiFetch( {
		path: addQueryArgs( '/' + restNamespace + '/properties', param ),
		method: 'GET',
	} ).then( ( res ) => {
		if ( res.data.content !== undefined ) {
			if ( isLoadmore ) {
				containerNode.insertAdjacentHTML( 'beforeend', res.data.content );
			} else {
				containerNode.innerHTML = res.data.content;
			}
			map = displayPropertyMapBound( map, res.data.property, 'realpress-swm-map-area' );
			triggerPopup( res.data.property );
		} else {
			map = displayPropertyMapBound( map, [], 'realpress-swm-map-area' );
			if ( loadMoreWrapperNode ) {
				loadMoreWrapperNode.style.display = 'none';
			}

			if ( res.msg && isLoadmore === false ) {
				containerNode.innerHTML = `<p>${ res.msg }</p>`;
			}
		}
		renderPagination( res );
	} ).catch( ( err ) => {
		console.log( err );
	} ).finally( () => {
		if ( isLoadmore === false ) {
			const urlPush = getUrl( query );
			window.history.pushState( '', '', urlPush );
		}
		containerNode.style.opacity = 1;
	} );
};

const sort = () => {
	sortNode.addEventListener( 'change', function( event ) {
		if ( reseting ) {
			return;
		}
		const selected = event.target.value;
		const sortParams = getOrderParams( selected );
		query = { ...query, ...sortParams };
		//Loadmore and infinite scroll
		if ( paginationType !== 'standard' && Object.hasOwn( query, 'page' ) ) {
			delete query.page;
		}
		getProperties( query );
	} );
};

const reset = () => {
	const resetButtonNode = searchNode.querySelector( 'button.realpress-reset' );
	if ( resetButtonNode ) {
		resetButtonNode.addEventListener( 'click', function() {
			reseting = true;
			query = {};
			getProperties( query );
			reseting = false;
		} );
	}
};

const search = () => {
	document.addEventListener( 'click', function( event ) {
		if ( event.target.classList.contains( 'realpress-search' ) || event.target.classList.contains( 'realpress-view-all' ) ) {
			query = getQuery( query );

			if ( Object.hasOwn( query, 'page' ) ) {
				delete query.page;
			}

			getProperties( query );
		}
	} );
};

const triggerPopup = ( properties ) => {
	const propertyItemNodes = containerNode.querySelectorAll( '.realpress-property-item' );
	if ( ! propertyItemNodes ) {
		return;
	}
	for ( let i = 0; i < propertyItemNodes.length; i++ ) {
		const propertyItemNode = propertyItemNodes[ i ];
		const propertyId = propertyItemNode.getAttribute( 'data-property-id' );

		propertyItemNode.addEventListener( 'mouseenter', function() {
			openPopup( map, propertyId, properties );
		} );
		propertyItemNode.addEventListener( 'mouseleave', function() {
			closePopup( map, propertyId );
		} );
	}
};

const renderPagination = ( res ) => {
	if ( paginationType === 'standard' ) {
		if ( res.data.pagination !== undefined ) {
			searchWithMapNode.querySelector( '.realpress-pagination' ).innerHTML = res.data.pagination;
		} else {
			searchWithMapNode.querySelector( '.realpress-pagination' ).innerHTML = '';
		}

		if ( res.data.from_to !== undefined ) {
			searchWithMapNode.querySelector( '.realpress-from-to' ).innerHTML = res.data.from_to;
		} else {
			searchWithMapNode.querySelector( '.realpress-from-to' ).innerHTML = '';
		}
	}

	if ( paginationType === 'loadmore' ) {
		if ( res.data.pagination === undefined ) {
			nextPage = null;
			return;
		}

		loadmoreBtnNode.innerHTML = res.data.pagination;
		loadingNode.style.display = 'none';
		if ( res.data.next_page ) {
			nextPage = res.data.next_page;
		} else {
			nextPage = null;
		}
	}

	if ( paginationType === 'infinite_scroll' ) {
		infiniteLoadingNode.style.display = 'none';
		isFetching = false;
		if ( res.data.next_page ) {
			nextPage = res.data.next_page;
		} else {
			nextPage = null;
		}
	}
};

const pagination = () => {
	document.addEventListener( 'click', function( event ) {
		const target = event.target;
		const item = target.closest( 'a' );
		if ( paginationType === 'standard' ) {
			if ( ! item ) {
				return;
			}

			if ( ! item.getAttribute( 'data-page' ) ) {
				return;
			}

			const paginationNode = target.closest( '.realpress-pagination' );
			if ( ! paginationNode ) {
				return;
			}
			event.preventDefault();
			const page = item.getAttribute( 'data-page' );
			query = { ...query, page };
			getProperties( query );
			searchWithMapNode.scrollIntoView( { behavior: 'smooth' } );
		}

		if ( paginationType === 'loadmore' ) {
			if ( target.parentNode !== loadmoreBtnNode ) {
				return;
			}

			event.preventDefault();
			target.remove();
			loadingNode.style.display = 'block';
			query = { ...query, page: nextPage };
			getProperties( query, true );
		}
	} );

	if ( paginationType === 'infinite_scroll' ) {
		window.addEventListener( 'scroll', ( event ) => {
			getScrollData();
		} );
	}
};

const getScrollData = () => {
	const distance = infiniteScrollNode.getBoundingClientRect().top - window.innerHeight;

	if ( isFetching === false && distance < 0 && nextPage ) {
		isFetching = true;
		infiniteLoadingNode.style.display = 'block';
		query = { ...query, page: nextPage };
		getProperties( query, true );
	}
};

export default realpressHalfMap;
